<template>
  <div class="game">
    <div class="h-banner">
      <div class="container">
        <h1>AI训练解决方案</h1>
        <div class="row">
          <p class="col-sm-7">AI训练解决方案是面向AI开发者的一站式开发解决方案，提供数据处理、算法构建、模型训练、模型部署等端到端的服务能力，覆盖整个AI开发的工作流程，帮助用户快速构建和部署模型。</p>
        </div>
      </div>
    </div>
    <div class="session-1">
      <div class="container">
        <div class="row"><div class="caption">方案优势</div></div>
        <ul class="row">
          <li class="col-md-6 col-sm-12 col-xs-12">
            <div class="li-wrap">
              <img src="@/assets/images/scheme/r_rendering_icon_01.png" alt="">
              <div class="des">
                <div class="title">海量资源按需计费</div>
                <div class="txt">分布式GPU/CPU服务器集群，基于分布式调度算法，对于大数据量训练，从“数周”缩短到“数小时”，包含英伟达和AMD最新的显卡。</div>
              </div>
            </div>
          </li>
          <li class="col-md-6 col-sm-12 col-xs-12">
            <div class="li-wrap">
              <img src="@/assets/images/scheme/r_rendering_icon_02.png" alt="">
              <div class="des">
                <div class="title">提升AI研发效率</div>
                <div class="txt">数据、算法。模型版本，训练结果等可视化管理。训练日志完善，过程可视化，可追溯，方便定位问题和性能优化。</div>
              </div>
            </div>
          </li>
          <li class="col-md-6 col-sm-12 col-xs-12">
            <div class="li-wrap">
              <img src="@/assets/images/scheme/r_rendering_icon_03.png" alt="">
              <div class="des">
                <div class="title">训练版本快速迭代</div>
                <div class="txt">全程站内处理，无需迁移；预置的成熟算法，预置开发环境，英伟达加速驱动等，可快速启动算法实验；一键部署及A/B测试功能，也加快了产品应用速度。</div>
              </div>
            </div>
          </li>
          <li class="col-md-6 col-sm-12 col-xs-12">
            <div class="li-wrap">
              <img src="@/assets/images/scheme/r_rendering_icon_04.png" alt="">
              <div class="des">
                <div class="title">一体化AI开发平台</div>
                <div class="txt">支持TensorFlow、MxNet、Caffe等多种主流框架，自动调度底层计算资源，无需开发人员搭建维护平台及环境，快速创建训练部署环境。</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="session-2">
      <div class="container">
        <div class="row"><div class="caption">应用实例</div></div>
        <div class="row">
          <div class="picture col-sm-7">
            <img src="@/assets/images/scheme/r_training_images_01.png" alt="">
          </div>
          <div class="introduce col-sm-5">
            <div class="title">AI云端开发、训练及部署</div>
            <p>平台提供了数据管理、模型构建、模型训练、模型部署等服务，覆盖整个AI开发过程的工作流程，满足AI开发者的日常开发、训练需求，AI开发人员可专注业务开发，无需考虑服务器自愿申请、环境搭建和上线部署运维。通过专用计算GPU、分布式训练，大幅降低训练时间及成本，缩短开发周期，快速迭代。</p>
          </div>
        </div>
      </div>
    </div>
    <div class="session-3">
      <div class="container">
        <div class="row"><div class="caption">应用场景</div></div>
        <div class="row">
          <ul>
            <li class="col-md-2 col-sm-4 col-xs-6">
              <div class="li-wrap">
                <div class="cont">
                  <img src="@/assets/images/scheme/r_training_icon_05.png" alt="">
                  <span>语音识别</span>
                </div>
              </div>
            </li>
            <li class="col-md-2 col-sm-4 col-xs-6">
              <div class="li-wrap">
                <div class="cont">
                  <img src="@/assets/images/scheme/r_training_icon_06.png" alt="">
                  <span>自然语言处理</span>
                </div>
              </div>
            </li>
            <li class="col-md-2 col-sm-4 col-xs-6">
              <div class="li-wrap">
                <div class="cont">
                  <img src="@/assets/images/scheme/r_training_icon_07.png" alt="">
                  <span>图像识别</span>
                </div>
              </div>
            </li>
            <li class="col-md-2 col-sm-4 col-xs-6">
              <div class="li-wrap">
                <div class="cont">
                  <img src="@/assets/images/scheme/r_training_icon_08.png" alt="">
                  <span>人脸识别</span>
                </div>
              </div>
            </li>
            <li class="col-md-2 col-sm-4 col-xs-6">
              <div class="li-wrap">
                <div class="cont">
                  <img src="@/assets/images/scheme/r_training_icon_09.png" alt="">
                  <span>知识图谱</span>
                </div>
              </div>
            </li>
            <li class="col-md-2 col-sm-4 col-xs-6">
              <div class="li-wrap">
                <div class="cont">
                  <img src="@/assets/images/scheme/r_training_icon_10.png" alt="">
                  <span>语音合成</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.h-banner{
  background: #282839;
  color: #fff;
  h1{
    font-size: 36px;
    font-weight: bold;
    margin-top: 70px;
  }
  p{
    font-size: 18px;
    color: #A2A2BB;
    margin-top: 20px;
    margin-bottom: 70px;
  }
}
.caption{
  margin-top: 80px;
}
@media (max-width: $screen-sm-min) {
  .caption{
    margin-top: 40px;
  }
}
.session-1{
  .caption{
    margin-bottom: 0;
  }
  ul{
    li{
      margin-top: 60px;
      .li-wrap{
        display: flex;
        img{
          display: block;
          width: 80px;
          height: 80px;
        }
        .des{
          margin-left: 20px;
          .title{
            font-size: 18px;
            font-weight: bold;
          }
          .txt{
            font-size: 14px;
            margin-top: 9px;
          }
        }
      }
    }
  }
}
.session-2{
  .picture{
    img{
      width: 100%;
      max-width: 714px;
      display: block;
    }
  }
  .introduce{
    .title{
      font-size: 24px;
      font-weight: bold;
      margin-top: 30px;
    }
    p{
      font-size: 14px;
      margin-top: 35px;
    }
  }
}
@media (max-width: $screen-sm-min) {
  .session-2{
    padding: 20px 0;
    .right{
      margin-top: 20px;
      .list{
        .list-item{
          & + .list-item{
            margin-top: 20px;
          }
          .des{
            p{
              margin-top: 6px;
            }
          }
        }
      }
    }
  }
}
.session-3{
  margin-bottom: 120px;
  .container{
    .caption{
      margin-bottom: 10px;
    }
    ul{
      li{
        margin-top: 30px;
        .li-wrap{
          box-shadow: 0px 2px 18px 0px rgba(122, 132, 165, 0.26);
          padding-bottom: 100%;
          border-radius: 24px;
          position: relative;
          .cont{
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              img{
                width: 36%;
                display: block;
                margin: 0 auto;
              }
              span{
                margin-top: 10%;
              }
          }
        }
      }
    }
  }
}
@media (max-width: $screen-sm-min) {
  .session-3{
    margin-bottom: 40px;
  }
}
</style>
